import { stringify } from 'query-string';
import { EntityTypes } from 'context/entityContext';

// Please take note: this is a POST endpoint. It requires a body that should be a JSON stringified array of entity IDs.
export default getEntityMetadataByIdsURL;

interface IEntityMetadataByIdsURLArgs {
  entityType: EntityTypes;
  expand?: 'metadata' | 'none';
  showGrouped?: boolean;
}

function getEntityMetadataByIdsURL(args: IEntityMetadataByIdsURLArgs): string {
  const { entityType, expand, showGrouped = true } = args;

  const params = stringify({
    expand,
    showGrouped,
  });

  return `/api/${entityType}/byIds${params && `?${params}`}`;
}
